import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import PageHero, { SectionHeading } from "../components/PageHero";

const options = [
  {
    name: "Academic Core",
    days: "Monday · Wednesday · Friday",
    body: "The academic heart of Angel of Peace, with focused instruction in the Classical Liberal Arts, Latin, Humanities, and Science.",
  },
  {
    name: "Enrichment & Formation",
    days: "Tuesday · Thursday",
    body: "Two days devoted to the broader formation of the person through the Catholic Faith, Mass, Sacred Music, Fine Arts, Practical Arts, Clubs, Electives, study, and community life.",
  },
  {
    name: "Complete Program",
    days: "Monday – Friday",
    body: "The complete Angel of Peace experience, combining the three-day academic core with two days of Spiritual, Artistic, Practical, and Communal formation.",
    featured: true,
  },
];

const SchoolFormat = () => {
  return (
    <PageLayout>
      <PageHero
        eyebrow="School Format"
        headline={<>A Balanced Rhythm for <em className="not-italic text-[#c9a961]">Learning and Formation</em>.</>}
        intro="A three-day academic core paired with two dedicated days for prayer, fine arts, physical education, and electives — one school in a rhythm that makes room for beauty, friendship, and unhurried work."
        illustration={<img src="/assets/calendar-large.png" alt="" className="w-full max-w-[420px] h-auto object-contain" />}
      />

      {/* Three Enrollment Options */}
      <section className="bg-[#fbf7ee]">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24">
          <SectionHeading eyebrow="One School · Multiple Ways to Participate" title="Choose the Rhythm That Serves Your Family." />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {options.map((o) => (
              <div
                key={o.name}
                className={`relative p-8 md:p-10 flex flex-col ${
                  o.featured
                    ? "bg-[#1e2952] text-[#fbf7ee] border border-[#c9a961]"
                    : "bg-[#fbf7ee] border border-[#e6dfc8]"
                }`}
              >
                {o.featured && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 font-sans-nav text-[10px] tracking-[0.3em] uppercase bg-[#c9a961] text-[#1e2952] px-4 py-1">
                    Full Experience
                  </div>
                )}
                <div className={`font-sans-nav text-[11px] tracking-[0.3em] uppercase mb-3 ${o.featured ? "text-[#c9a961]" : "text-[#c9a961]"}`}>Program</div>
                <h3 className="font-display text-[24px] md:text-[26px] leading-tight mb-2" style={{ fontWeight: 600 }}>{o.name}</h3>
                <div className={`font-serif-body italic text-[15px] mb-5 ${o.featured ? "text-[#c9a961]" : "text-[#8a7a4e]"}`}>{o.days}</div>
                <div className="h-px w-14 bg-[#c9a961] mb-5"></div>
                <p className={`font-serif-body text-[15px] leading-[1.75] ${o.featured ? "text-[#e8e2cf]" : "text-[#3a466e]"}`}>{o.body}</p>
                {o.detail && (
                  <p className={`font-serif-body text-[14px] leading-[1.75] italic mt-4 ${o.featured ? "text-[#c9a961]" : "text-[#8a7a4e]"}`}>{o.detail}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Explore Academics link box */}
      <section className="bg-[#fbf7ee]">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 lg:px-14 pt-2 pb-14 text-center">
          <Link
            to="/academics"
            data-testid="school-format-cta-academics"
            className="inline-block font-sans-nav text-[12px] tracking-[0.28em] uppercase px-10 py-4 border border-[#c9a961] text-[#1e2952] hover:bg-[#c9a961] hover:text-[#fbf7ee] transition-colors"
          >
            Explore Academics
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#1e2952] text-[#fbf7ee]">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 lg:px-14 py-20 text-center">
          <h2 className="font-display text-[28px] md:text-[38px] leading-tight" style={{ fontWeight: 500 }}>
            Discover Whether Angel of Peace Is Right for Your Family.
          </h2>
          <div className="mt-6 flex items-center justify-center gap-3">
            <span className="block h-px w-40 bg-[#c9a961]"></span>
            <span className="text-[#c9a961]">†</span>
            <span className="block h-px w-40 bg-[#c9a961]"></span>
          </div>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-5">
            <Link
              to="/inquire"
              data-testid="school-format-cta-inquire"
              className="inline-block font-sans-nav text-[12px] tracking-[0.28em] uppercase px-10 py-4 bg-[#c9a961] text-[#1e2952] hover:bg-[#e2c98a] transition-colors"
            >
              Inquire Today
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default SchoolFormat;
